import { css } from "@compiled/react";
import Lottie, { Options, EventListener } from "react-lottie";

import { media } from "@atlaskit/primitives";

const wireFrameStyle = css({
    overflow: "hidden",
    zIndex: 1
});

const animationBrandRefreshExpStyle = css({
    height: 500,
    [media.above.sm]: {
        maxHeight: "800px",
        marginBlockStart: "-100px"
    }
});

interface LottieAnimationProps {
    options: Options;
    eventListener: EventListener[] | undefined;
    isAnimationBrandRefresh?: boolean;
}

export const LottieAnimation = ({
    options,
    eventListener,
    isAnimationBrandRefresh = false
}: LottieAnimationProps) => (
    <div
        css={[
            wireFrameStyle,
            isAnimationBrandRefresh && animationBrandRefreshExpStyle
        ]}
    >
        <Lottie options={options} eventListeners={eventListener} />
    </div>
);
